import { Link, Typography } from "@mui/material";
import {
  createBrowserRouter,
  Navigate,
  Params,
  Link as RouterLink,
} from "react-router-dom";
import AssignmentPeriodForm from "../features/assignmentPeriod/AssignmentPeriodForm";
import { assignmentPeriodAction } from "../features/assignmentPeriod/createAction";
import { assignmentPeriodLoader } from "../features/assignmentPeriod/laoder";
import AssignmentPeriodsDataGrid from "../features/assignmentPeriods/DataGrid";
import { assignmentPeriodListLoader } from "../features/assignmentPeriods/laoder";
import AssignmentPeriodMainGrid from "../features/assignmentPeriods/MainGrid";
import AuthTemplateFrame from "../features/auth/AuthTemplateFrame";
import EmailConfimPage from "../features/auth/confimEmail/EmailConfimPage";
import EmailConfirmErrorPage from "../features/auth/confimEmail/EmailConfirmrErorPage";
import { confirmEmailLoader } from "../features/auth/confimEmail/laoder";
import SignInPage from "../features/auth/login/SignInPage";
import { resetPasswordAction } from "../features/auth/resetPassword/createAction";
import { resetPasswordLoader } from "../features/auth/resetPassword/laoder";
import ResetPasswordPage from "../features/auth/resetPassword/ResetPasswordPage";
import CityDataGrid from "../features/cities/DataGrid";
import { cityListLoader } from "../features/cities/laoder";
import CityMainGrid from "../features/cities/MainGrid";
import CityForm from "../features/city/CityForm";
import { cityAction } from "../features/city/createAction";
import { cityLoader } from "../features/city/laoder";
import MainGrid from "../features/dashboard/components/MainGrid";
import Dashboard from "../features/dashboard/Dashboard";
import { hospitalAction } from "../features/hospital/createAction";
import HospitalForm from "../features/hospital/HospitalForm";
import { hospitalLoader } from "../features/hospital/laoder";
import HospitalDataGrid from "../features/hospitals/DataGrid";
import { hospitalListLoader } from "../features/hospitals/laoder";
import HospitalsMainGrid from "../features/hospitals/MainGrid";
import { logLoader } from "../features/log/laoder";
import LogForm from "../features/log/LogForm";
import LogDataGrid from "../features/logs/DataGrid";
import { logListLoader } from "../features/logs/laoder";
import LogsMainGrid from "../features/logs/MainGrid";
import EmailLogDataGrid from "../features/emailLogs/DataGrid";
import { emailLogListLoader, emailLogLoader } from "../features/emailLogs/laoder";
import EmailLogsMainGrid from "../features/emailLogs/MainGrid";
import EmailLogForm from "../features/emailLogs/EmailLogForm";
import SmtpAccountsMainGrid from "../features/smtpAccounts/MainGrid";
import SmtpAccountsPanel from "../features/smtpAccounts/SmtpAccountsPanel";
import { smtpAccountsLoader } from "../features/smtpAccounts/api";
import UnconfirmedUsersMainGrid from "../features/unconfirmedUsers/MainGrid";
import UnconfirmedUsersPanel from "../features/unconfirmedUsers/UnconfirmedUsersPanel";
import { unconfirmedUsersLoader } from "../features/unconfirmedUsers/api";
import PreferencesDataGrid from "../features/preferences/DataGrid";
import PreferencesInputFileUpload from "../features/preferences/imports/ImportData";
import { uploadPreferencesAction } from "../features/preferences/imports/uploadAction";
import { preferencesListLoader } from "../features/preferences/laoder";
import PreferencesMainGrid from "../features/preferences/MainGrid";
import { professionAction } from "../features/profession/createAction";
import { professionLoader } from "../features/profession/laoder";
import ProfessionForm from "../features/profession/ProfessionForm";
import ProfessionDataGrid from "../features/professions/DataGrid";
import { professionListLoader } from "../features/professions/laoder";
import ProfessionMainGrid from "../features/professions/MainGrid";
import { purchaseLoader } from "../features/purchase/laoder";
import PurchaseForm from "../features/purchase/PruchaseForm";
import PurchaseDataGrid from "../features/purchases/DataGrid";
import { purchaseListLoader } from "../features/purchases/laoder";
import PurchasesMainGrid from "../features/purchases/MainGrid";
import { systemChatLoader } from "../features/systemChat/laoder";
import SystemChatMainGrid from "../features/systemChat/MainGrid";
import SystemChatForm from "../features/systemChat/SystemChatForm";
import SystemChatDataGrid from "../features/systemChats/DataGrid";
import { systemChatListLoader } from "../features/systemChats/laoder";
import SystemsChatsMainGrid from "../features/systemChats/MainGrid";
import { userAction } from "../features/user/createAction";
import { userLoader } from "../features/user/laoder";
import UserMainGrid from "../features/user/MainGrid";
import UserForm from "../features/user/UserForm";
import { userPrefencesAction } from "../features/userPreferences/createAction";
import { userPreferenceListLoader } from "../features/userPreferences/laoder";
import UserPreferencesMainGrid from "../features/userPreferences/MainGrid";
import PreferencesPage from "../features/userPreferences/Simulation";
import UserDataGrid from "../features/users/DataGrid";
import { userListLoader } from "../features/users/laoder";
import UsersMainGrid from "../features/users/MainGrid";
import AccountDeletion from "../pages/AccountDeleteInstruction";
import ErrorPage from "../pages/ErrorPage";
import ParamsTypography from "./ParamsTypography";
import PublicMainPage from "./PublicMainPage";
import ExamInputFileUpload from "../features/exams/imports/ImportData";
import { uploadExamAction } from "../features/exams/imports/uploadAction";
import ExamsMainGrid from "../features/exams/MainGrid";
import { importStatusLaoder } from "../features/exams/imports/importStatusLaoder";
import UploadStatus from "../features/exams/imports/UploadStatus";
import { examListLoader } from "../features/exams/laoder";
import ExamDataGrid from "../features/exams/DataGrid";
import { examLoader } from "../features/exam/laoder";
import ExamPanel from "../features/exam/ExamForm";
import ExamTypeMainGrid from "../features/examTypes/MainGrid";
import { examTypeListLoader } from "../features/examTypes/laoder";
import ExamTypeDataGrid from "../features/examTypes/DataGrid";
import { examTypeLoader } from "../features/examType/laoder";
import ExamTypeForm from "../features/examType/ExamTypeForm";
import { examTypeAction } from "../features/examType/createAction";
import { examTypeCategoryListLoader } from "../features/examTypeCategories/laoder";
import ExamTypeCategoryForm from "../features/examTypeCategory/ExamTypeCategoryForm";
import { examTypeCategoryLoader } from "../features/examTypeCategory/laoder";
import { examTypeCategoryAction } from "../features/examTypeCategory/createAction";
import ExamTypeCategoryDataGrid from "../features/examTypeCategories/DataGrid";
import ExamTypeSummary from "../features/exams/dashboard/Summary";
import { examSummaryLoader } from "../features/exams/dashboard/laoder";
import { systemChatListlaoderLastUnRead } from "../features/systemChats/laoderLastUnRead";
import ChatsMainGrid from "../features/chats/MainGrid";
import ChatDataGrid from "../features/chats/DataGrid";
import { ChatListLoader } from "../features/chats/laoder";
import ChatForm from "../features/chat/ChatForm";
import { chatLoader } from "../features/chat/laoder";
import { chatAction } from "../features/chat/createAction";
import ChatConversation from "../features/chatConversation/ChatConversation";
import { chatConversationLoader } from "../features/chatConversation/laoder";
import UserChatsDataGrid from "../features/userChats/UserChatsDataGrid";
import { userChatsLoader } from "../features/userChats/laoder";

// Router'lar modül yüklenirken değil, ihtiyaç anında oluşturulur: createBrowserRouter
// oluşturulduğu anda o URL için loader'ları çalıştırır; oturum henüz hazır değilken
// (süresi dolmuş token, giriş yapılmamış) çalışırsa bayat hata state'i oluşur.
const createAuthRouter = () =>
  createBrowserRouter([
  {
    path: "/",
    element: <Dashboard />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: <MainGrid />,
        loader: systemChatListlaoderLastUnRead,
      },
      {
        path: "/cities",
        element: <CityMainGrid />,
        handle: {
          crumb: () => (
            <Link to="/cities" component={RouterLink} variant="body1">
              {"Şehirler"}
            </Link>
          ),
        },
        children: [
          {
            index: true,
            loader: cityListLoader,
            element: <CityDataGrid />,
          },
          {
            path: "/cities:cityCode",
            element: <CityForm />,
            action: cityAction,
            loader: cityLoader,
            handle: {
              crumb: (params: Readonly<Params<string>>) => (
                <ParamsTypography
                  text={`${params.cityCode}`}
                  to={`/cities/${params.cityCode}`}
                />
              ),
            },
          },
        ],
      },
      {
        path: "/chats",
        element: <ChatsMainGrid />,
        handle: {
          crumb: () => (
            <Link to="/chats" component={RouterLink} variant="body1">
              {"Yazışmalar"}
            </Link>
          ),
        },
        children: [
          {
            index: true,
            loader: ChatListLoader,
            element: <ChatDataGrid />,
          },
          {
            path: "conversation/:hospitalId",
            element: <ChatConversation />,
            loader: chatConversationLoader,
            handle: {
              crumb: (params: Readonly<Params<string>>) => (
                <ParamsTypography
                  text="Yazışma"
                  to={`/chats/conversation/${params.hospitalId}`}
                />
              ),
            },
          },
          {
            path: "/chats:id",
            element: <ChatsMainGrid />,
            handle: {
              crumb: (params: Readonly<Params<string>>) => (
                <ParamsTypography
                  text={`${params.id}`}
                  to={`/chats/${params.id}`}
                />
              ),
            },
            children: [
              {
                index: true,
                element: <ChatForm />,
                loader: chatLoader,
                action: chatAction,
              },
            ],
          },
        ],
      },
      {
        path: "/logs",
        element: <LogsMainGrid />,
        handle: {
          crumb: () => (
            <Link to="/logs" component={RouterLink} variant="body1">
              {"Loglar"}
            </Link>
          ),
        },
        children: [
          {
            index: true,
            loader: logListLoader,
            element: <LogDataGrid />,
          },
          {
            path: "/logs:id",
            element: <LogsMainGrid />,
            handle: {
              crumb: (params: Readonly<Params<string>>) => (
                <ParamsTypography
                  text={`${params.id}`}
                  to={`/logs/${params.id}`}
                />
              ),
            },
            children: [
              {
                index: true,
                element: <LogForm />,
                loader: logLoader,
              },
            ],
          },
        ],
      },
      {
        path: "/smtpAccounts",
        element: <SmtpAccountsMainGrid />,
        handle: {
          crumb: () => (
            <Link to="/smtpAccounts" component={RouterLink} variant="body1">
              {"Mail Sunucuları"}
            </Link>
          ),
        },
        children: [
          {
            index: true,
            loader: smtpAccountsLoader,
            element: <SmtpAccountsPanel />,
          },
        ],
      },
      {
        path: "/unconfirmedUsers",
        element: <UnconfirmedUsersMainGrid />,
        handle: {
          crumb: () => (
            <Link to="/unconfirmedUsers" component={RouterLink} variant="body1">
              {"Onaysız Kullanıcılar"}
            </Link>
          ),
        },
        children: [
          {
            index: true,
            loader: unconfirmedUsersLoader,
            element: <UnconfirmedUsersPanel />,
          },
        ],
      },
      {
        path: "/emailLogs",
        element: <EmailLogsMainGrid />,
        handle: {
          crumb: () => (
            <Link to="/emailLogs" component={RouterLink} variant="body1">
              {"Email Logları"}
            </Link>
          ),
        },
        children: [
          {
            index: true,
            loader: emailLogListLoader,
            element: <EmailLogDataGrid />,
          },
          {
            path: "/emailLogs:id",
            element: <EmailLogsMainGrid />,
            handle: {
              crumb: (params: Readonly<Params<string>>) => (
                <ParamsTypography
                  text={`${params.id}`}
                  to={`/emailLogs/${params.id}`}
                />
              ),
            },
            children: [
              {
                index: true,
                element: <EmailLogForm />,
                loader: emailLogLoader,
              },
            ],
          },
        ],
      },
      {
        path: "/purchases",
        element: <PurchasesMainGrid />,
        handle: {
          crumb: () => (
            <Link to="/purchases" component={RouterLink} variant="body1">
              {"Satın Almalar"}
            </Link>
          ),
        },
        children: [
          {
            index: true,
            loader: purchaseListLoader,
            element: <PurchaseDataGrid />,
          },
          {
            path: "/purchases:id",
            element: <PurchasesMainGrid />,
            handle: {
              crumb: (params: Readonly<Params<string>>) => (
                <ParamsTypography
                  text={`${params.id}`}
                  to={`/purchases/${params.id}`}
                />
              ),
            },
            children: [
              {
                index: true,
                element: <PurchaseForm />,
                loader: purchaseLoader,
              },
            ],
          },
        ],
      },
      {
        path: "/systemChats",
        element: <SystemsChatsMainGrid />,
        handle: {
          crumb: () => (
            <Link to="/systemChats" component={RouterLink} variant="body1">
              {"Sistem Mesajları"}
            </Link>
          ),
        },
        children: [
          {
            index: true,
            loader: systemChatListLoader,
            element: <SystemChatDataGrid />,
          },
          {
            path: "/systemChats:userId",
            element: <SystemChatMainGrid />,
            id: "systemChatRoute",
            handle: {
              crumb: (params: Readonly<Params<string>>) => (
                <ParamsTypography
                  text={`${params.userId}`}
                  to={`/systemChats/${params.userId}`}
                />
              ),
            },
            loader: systemChatLoader,
            children: [
              {
                index: true,
                element: <SystemChatForm />,
              },
            ],
          },
        ],
      },
      {
        path: "/users",
        element: <UsersMainGrid />,
        handle: {
          crumb: () => (
            <Link to="/users" component={RouterLink} variant="body1">
              {"Kullanıcılar"}
            </Link>
          ),
        },
        children: [
          {
            index: true,
            loader: userListLoader,
            element: <UserDataGrid />,
          },
          {
            path: "/users:id",
            element: <UserMainGrid />,
            handle: {
              crumb: (params: Readonly<Params<string>>) => (
                <ParamsTypography
                  text={`${params.id}`}
                  to={`/users/${params.id}`}
                />
              ),
            },
            children: [
              {
                index: true,
                element: <UserForm />,
                action: userAction,
                loader: userLoader,
              },
              {
                path: "preferences",
                element: <UserPreferencesMainGrid />,
                handle: {
                  crumb: (params: Readonly<Params<string>>) => (
                    <Link
                      to={`/users/${params.id}/preferences`}
                      component={RouterLink}
                      variant="body1"
                    >
                      {"Tercihler"}
                    </Link>
                  ),
                },
                children: [
                  {
                    index: true,
                    action: userPrefencesAction,
                    loader: userPreferenceListLoader,
                    element: <PreferencesPage />,
                  },
                ],
              },
              {
                path: "chats",
                element: <UserChatsDataGrid />,
                loader: userChatsLoader,
                handle: {
                  crumb: (params: Readonly<Params<string>>) => (
                    <Link
                      to={`/users/${params.id}/chats`}
                      component={RouterLink}
                      variant="body1"
                    >
                      {"Yazışmalar"}
                    </Link>
                  ),
                },
              },
            ],
          },
        ],
      },
      {
        path: "/professions",
        element: <ProfessionMainGrid />,
        handle: {
          crumb: () => (
            <Link to="/professions" component={RouterLink} variant="body1">
              {"Branşlar"}
            </Link>
          ),
        },
        children: [
          {
            index: true,
            loader: professionListLoader,
            element: <ProfessionDataGrid />,
          },
          {
            path: "/professions:professionCode",
            element: <ProfessionForm />,
            action: professionAction,
            loader: professionLoader,
            handle: {
              crumb: (params: Readonly<Params<string>>) => (
                <ParamsTypography
                  text={`${params.professionCode}`}
                  to={`/professions/${params.professionCode}`}
                />
              ),
            },
          },
        ],
      },
      {
        path: "/hospitals",
        element: <HospitalsMainGrid />,
        handle: {
          crumb: () => (
            <Link to="/hospitals" component={RouterLink} variant="body1">
              {"Hastaneler"}
            </Link>
          ),
        },
        children: [
          {
            index: true,
            loader: hospitalListLoader,
            element: <HospitalDataGrid />,
          },
          {
            path: "/hospitals:id",
            element: <HospitalForm />,
            action: hospitalAction,
            loader: hospitalLoader,
            handle: {
              crumb: (params: Readonly<Params<string>>) => (
                <ParamsTypography
                  text={`${params.id}`}
                  to={`/hospitals/${params.id}`}
                />
              ),
            },
          },
        ],
      },
      {
        path: "/assignment-periods",
        element: <AssignmentPeriodMainGrid />,
        handle: {
          crumb: () => (
            <Link
              to="/assignment-periods"
              component={RouterLink}
              variant="body1"
            >
              {"Atama Dönemleri"}
            </Link>
          ),
        },
        children: [
          {
            index: true,
            loader: assignmentPeriodListLoader,
            element: <AssignmentPeriodsDataGrid />,
          },
          {
            path: "/assignment-periods:assignmentPeriodCode",
            handle: {
              crumb: (params: Readonly<Params<string>>) => (
                <ParamsTypography
                  text={`${params.assignmentPeriodCode}`}
                  to={`/assignment-periods/${params.assignmentPeriodCode}`}
                />
              ),
            },
            children: [
              {
                loader: assignmentPeriodLoader,
                action: assignmentPeriodAction,
                index: true,
                element: <AssignmentPeriodForm />,
              },
              {
                path: "preferences",
                element: <PreferencesMainGrid />,
                handle: {
                  crumb: (params: Readonly<Params<string>>) => (
                    <ParamsTypography
                      text="Tercihler"
                      to={`/assignment-periods/${params.assignmentPeriodCode}/preferences`}
                    />
                  ),
                },
                children: [
                  {
                    index: true,
                    loader: preferencesListLoader,
                    element: <PreferencesDataGrid />,
                  },
                  {
                    path: "upload",
                    element: <PreferencesInputFileUpload />,
                    action: uploadPreferencesAction,
                    handle: {
                      crumb: () => (
                        <Typography variant="body1">{"İçe Aktar"}</Typography>
                      ),
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: "/exams",
        element: <ExamsMainGrid />,
        handle: {
          crumb: () => (
            <Link to="/exams" component={RouterLink} variant="body1">
              {"Sınavlar"}
            </Link>
          ),
        },
        children: [
          {
            index: true,
            loader: examListLoader,
            element: <ExamDataGrid />,
          },
          {
            path: "/exams:examId",
            element: <ExamsMainGrid />,
            handle: {
              crumb: (params: Readonly<Params<string>>) => (
                <ParamsTypography
                  text={`${params.examId}`}
                  to={`/exams/${params.examId}`}
                />
              ),
            },
            children: [
              {
                index: true,
                element: <ExamPanel />,
                loader: examLoader,
              },
              {
                path: "status",
                element: <UploadStatus />,
                loader: importStatusLaoder,
                handle: {
                  crumb: () => (
                    <Typography variant="body1">{"Upload Durumu"}</Typography>
                  ),
                },
              },
            ],
          },
          {
            path: "upload",
            element: <ExamInputFileUpload />,
            action: uploadExamAction,
            handle: {
              crumb: () => (
                <Typography variant="body1">{"İçe Aktar"}</Typography>
              ),
            },
          },
        ],
      },
      {
        path: "/examTypes",
        element: <ExamTypeMainGrid />,
        handle: {
          crumb: () => (
            <Link to="/examType" component={RouterLink} variant="body1">
              {"Sınav Tipleri"}
            </Link>
          ),
        },
        children: [
          {
            index: true,
            loader: examSummaryLoader,
            element: <ExamTypeSummary />,
          },
          {
            path: "/examTypes:code",
            element: <ExamTypeMainGrid />,
            handle: {
              crumb: (params: Readonly<Params<string>>) => (
                <ParamsTypography
                  text={`${params.code}`}
                  to={`/examTypes/${params.code}`}
                />
              ),
            },
            children: [
              {
                index: true,
                element: <ExamTypeForm />,
                loader: examTypeLoader,
                action: examTypeAction,
              },
            ],
          },
        ],
      },
      {
        path: "/examTypeCategories/:examTypeCode",
        element: <ExamTypeMainGrid />,
        handle: {
          crumb: (params: Readonly<Params<string>>) => (
            <Link
              to={`/examTypeCategories/${params.examTypeCode}`}
              component={RouterLink}
              variant="body1"
            >
              {`${params.examTypeCode} Sınav Tipi Kategorileri`}
            </Link>
          ),
        },
        children: [
          {
            index: true,
            loader: examTypeCategoryListLoader,
            element: <ExamTypeCategoryDataGrid />,
          },
          {
            path: "/examTypeCategories/:examTypeCode/:categoryCode",
            element: <ExamTypeMainGrid />,
            handle: {
              crumb: (params: Readonly<Params<string>>) => (
                <ParamsTypography
                  text={`${params.categoryCode}`}
                  to={`/examTypes/${params.examTypeCode}/${params.categoryCode}`}
                />
              ),
            },
            children: [
              {
                index: true,
                element: <ExamTypeCategoryForm />,
                loader: examTypeCategoryLoader,
                action: examTypeCategoryAction,
              },
            ],
          },
        ],
      },
    ],
  },
  // Giriş yapıldıktan sonra URL /login vb. sayfalarda kalırsa ana sayfaya yönlendir
  { path: "/login", element: <Navigate to="/" replace /> },
  { path: "/reset-password", element: <Navigate to="/" replace /> },
]);

// sessionEnded: oturum az önce bittiyse (süre dolumu / logout) kullanıcı hangi
// sayfada olursa olsun login'e götürülür; "oturum süresi doldu" uyarısı orada gösterilir.
const createUnAuthRouter = (opts?: { sessionEnded?: boolean }) => {
  if (opts?.sessionEnded && window.location.pathname !== "/login")
    window.history.replaceState(null, "", "/login");
  return createBrowserRouter([
  {
    path: "/",
    element: <PublicMainPage />,
  },
  {
    path: "/",
    element: <AuthTemplateFrame />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "login",
        element: <SignInPage />,
        errorElement: <ErrorPage />,
      },
      {
        path: "reset-password",
        element: <ResetPasswordPage />,
        action: resetPasswordAction,
        loader: resetPasswordLoader,
        errorElement: <ErrorPage />,
      },
      {
        path: "confirm-email",
        element: <EmailConfimPage />,
        loader: confirmEmailLoader,
        errorElement: <EmailConfirmErrorPage />,
      },
      {
        path: "delete-account",
        element: <AccountDeletion />,
      },
    ],
  },
  // Oturum yokken korumalı bir URL'de kalınırsa (ör. logout sonrası) login'e yönlendir
  { path: "*", element: <Navigate to="/login" replace /> },
  ]);
};
export { createAuthRouter, createUnAuthRouter };
